// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"_1y8D1XvqC8AE8SOSzC8qpT","menuItemContainer":"_1-3owDVcVFGRRaGLnWfmeB"};